import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCircleInfo"><Path d="M10.5 10.5H12L12 15.5M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.75 8.125H11.625V8.25V8.75V8.875H11.75H12.25H12.375V8.75V8.25V8.125H12.25H11.75Z" fill="currentColor" stroke="currentColor" strokeWidth="0.25"/></CentralIconBase>;
});

export default IconCircleInfo;
